import type { PublicRuntimeConfig } from "@/lib/config/publicRuntimeConfig";
import { clearCognitoOAuthClientStorage } from "./clearCognitoOAuthClientStorage";
import { getCognitoUserManager } from "./cognitoOidcSettings";

export const runCognitoLogin = async (
  config: PublicRuntimeConfig,
): Promise<void> => {
  clearCognitoOAuthClientStorage();
  const returnTo = window.location.pathname + window.location.search;
  const userManager = getCognitoUserManager(config);
  await userManager.signinRedirect({
    state: { returnTo },
  });
};
